import React from "react";
import PropTypes from "prop-types";

function ProteinAtlasGeneralInfoTable({ items }) {
  return (
    <div className="tw-ml-6 tw-mr-6 tw-mt-4 tw-mb-6">
      <table className="tw-w-full">
        <thead className="">
          <tr>
            <th
              className="font-helvetica tw-pt-2 tw-pb-2 tw-pl-8 tw-bg-saphetorBlue tw-text-white"
              colSpan="2"
            >
              General Information
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((x) => {
            return (
              <tr className="tw-border-b tw-pt-2 tw-pb-2" key={x.key}>
                <td className="font-helvetica tw-pl-4 tw-text-gray-900 tw-bg-coolGray-200">
                  {x.key}
                </td>
                <td className="font-helvetica tw-pl-4">{x.value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

ProteinAtlasGeneralInfoTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

ProteinAtlasGeneralInfoTable.defaultProps = {
  items: null,
};
export default ProteinAtlasGeneralInfoTable;
